import { createSlice } from "@reduxjs/toolkit";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
  fetchSectionsBySubjectThunk,
  fetchChaptersThunk,
  createChapterThunk,
  updateChapterThunk,
  deleteChapterThunk,
} from "./chapterThunk";

const initialState = {
  classes: [],
  subjects: [],
  chapters: [],
  sections: [],
  selectedClassId: "",
  selectedSubjectId: "",
  selectedSectionId: "",
  selectedChapterId: "",
  loadingClasses: false,
  loadingSubjects: false,
  loadingSections: false,
  loadingChapters: false,
  chapterName: "",
  editingChapter: null,
};

const chapterSlice = createSlice({
  name: "chapter",
  initialState,
  reducers: {
    setSelectedClassId: (state, action) => {
      state.selectedClassId = action.payload;
    },
    setSelectedSubjectId: (state, action) => {
      state.selectedSubjectId = action.payload;
    },
    setSelectedSectionId: (state, action) => {
      state.selectedSectionId = action.payload;
    },
    setSelectedChapterId: (state, action) => {
      state.selectedChapterId = action.payload;
    },
    setChapterName: (state, action) => {
      state.chapterName = action.payload;
    },
    setEditingChapter: (state, action) => {
      state.editingChapter = action.payload;
    },
    setSubjects: (state, action) => {
      state.subjects = action.payload;
    },
    setSections: (state, action) => {
      state.sections = action.payload;
    },
    setChapters: (state, action) => {
      state.chapters = action.payload;
    },
    setClasses: (state, action) => {
      state.classes = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchClassesThunk.pending, (state) => {
        state.loadingClasses = true;
      })
      .addCase(fetchClassesThunk.fulfilled, (state, action) => {
        state.classes = action.payload;
        state.loadingClasses = false;
      })
      .addCase(fetchClassesThunk.rejected, (state) => {
        state.loadingClasses = false;
      })

      // Fetch Subjects
      .addCase(fetchSubjectsByClassThunk.pending, (state) => {
        state.loadingSubjects = true;
      })
      .addCase(fetchSubjectsByClassThunk.fulfilled, (state, action) => {
        state.subjects = action.payload;
        state.loadingSubjects = false;
      })
      .addCase(fetchSubjectsByClassThunk.rejected, (state) => {
        state.loadingSubjects = false;
      })
      // Fetch Sections
      .addCase(fetchSectionsBySubjectThunk.pending, (state) => {
        state.loadingSections = true;
      })
      .addCase(fetchSectionsBySubjectThunk.fulfilled, (state, action) => {
        state.sections = action.payload;
        state.loadingSections = false;
      })
      .addCase(fetchSectionsBySubjectThunk.rejected, (state) => {
        state.loadingSections = false;
      })

      // Fetch Chapters
      .addCase(fetchChaptersThunk.pending, (state) => {
        state.loadingChapters = true;
      })
      .addCase(fetchChaptersThunk.fulfilled, (state, action) => {
        state.chapters = action.payload;
        state.loadingChapters = false;
      })
      .addCase(fetchChaptersThunk.rejected, (state) => {
        state.loadingChapters = false;
      })

      // Create Chapter
      .addCase(createChapterThunk.fulfilled, (state, action) => {
        state.chapters.push(action.payload);
      })

      // Update Chapter
      .addCase(updateChapterThunk.fulfilled, (state, action) => {
        const index = state.chapters.findIndex(
          (c) => c.chapter_id === action.payload.chapter_id
        );
        if (index !== -1) {
          state.chapters[index] = action.payload;
        }
      })

      // Delete Chapter
      .addCase(deleteChapterThunk.fulfilled, (state, action) => {
        state.chapters = state.chapters.filter(
          (c) => c.chapter_id !== action.payload
        );
      });
  },
});

export const {
  setSelectedClassId,
  setSelectedSubjectId,
  setSelectedSectionId,
  setSelectedChapterId,
  setChapterName,
  setEditingChapter,
  setSubjects,
  setSections,
  setChapters,
  setClasses,
} = chapterSlice.actions;

export default chapterSlice.reducer;
